import ruMessages from "../locales/ru_RU.json";
import { LangConfig } from "../model";

export const RuLang: LangConfig = {
  messages: {
    ...ruMessages,
  },
  locale: "ru-RU",
};
